import React, { useState, useEffect } from 'react';
import { Manage } from '../shared/Manage';
import { KeenIcon } from '@/components';
import { Checkbox } from '@/components/ui/input/checkbox';
//import { AttachFileModal } from '../shared/AttachFileModal'; // Không dùng nữa
import { AttachFileManagerModal } from '../shared/AttachFileManagerModal'; // Sử dụng modal mới


// Dữ liệu mẫu
const mockData = [
  {
    id: 1,
    name: 'Tiêu đề mẫu 1',
    date: '20/05/2025',
    data: 'Đây là nội dung mẫu số 1. Bạn có thể sử dụng nội dung này để kiểm tra giao diện hoặc tính năng hiển thị.'
  },
  {
    id: 2,
    name: 'Tiêu đề mẫu 2',
    date: '21/05/2025',
    data: 'Đây là nội dung mẫu số 2. Thông tin có thể được thay đổi hoặc mở rộng tùy vào yêu cầu thực tế.'
  },
  {
    id: 3,
    name: 'Tiêu đề mẫu 3',
    date: '22/05/2025',
    data: 'Nội dung mẫu số 3 cung cấp văn bản giả định để mô phỏng dữ liệu thực tế trong hệ thống.'
  },
  {
    id: 4,
    name: 'Tiêu đề mẫu 4',
    date: '23/05/2025',
    data: 'Văn bản mẫu số 4 dùng để kiểm tra cách bố trí và xử lý nội dung trong ứng dụng.'
  }
];


// Cấu hình cột
const columns = [
  { key: 'name', label: 'Name', type: 'text', width: '15%' },
  { key: 'source', label: 'Source', type: 'text', width: '15%' },
  { key: 'date', label: 'Date Create', type: 'text', width: '20%' },
  { key: 'data', label: 'Detail', type: 'text', width: '40%' }
];

const ManageAttach = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isAutoExtractEnabled, setIsAutoExtractEnabled] = useState(false);
  const [showAttachFileManagerModal, setShowAttachFileManagerModal] = useState(false); // State cho modal mới

  // Giả lập fetch data
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setData(mockData);
      setLoading(false);
    },200);
  }, []);

  // Xử lý các sự kiện
  const handleEdit = (item) => {
    console.log('Edit item:', item);
    // TODO: logic edit
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = () => {
    if (selectedItem) {
      setData(prev => prev.filter(i => i.id !== selectedItem.id));
    }
    setShowDeleteConfirm(false);
    setSelectedItem(null);
  };

  const cancelAction = () => {
    setShowDeleteConfirm(false);
    setSelectedItem(null);
  };

  const handleOpenAttachFileManagerModal = () => {
    setShowAttachFileManagerModal(true);
  };

  const handleCloseAttachFileManagerModal = () => {
    setShowAttachFileManagerModal(false);
  };

  const handleSaveAttachFile = (fileData) => {
    console.log('File data received:', fileData);
    // TODO: Implement logic to handle the saved file data (e.g., upload, add to list)
    // For now, just add to mock data for demonstration (remove in production)
    const newFile = {
      id: data.length + 1,
      name: fileData.name || 'Untitled File',
      source: fileData.file ? fileData.file.name : 'N/A',
      date: new Date().toLocaleDateString(),
      data: fileData.detail || 'No detail provided',
    };
    setData(prev => [...prev, newFile]);
    handleCloseAttachFileManagerModal(); // Đóng modal sau khi lưu
  };

  const totalPages = data.length;

  const handlePrev = () => {
    setCurrentPage((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setCurrentPage((prev) => (prev < totalPages - 1 ? prev + 1 : prev));
  };

  // Sử dụng giá trị trực tiếp cho message xác nhận xóa
  const deleteConfirmMessageText = "Bạn có chắc chắn muốn xóa dữ liệu này không?";

  return (
    <div className="flex flex-col">
      {/* Header with button and checkbox */}
      <div className="flex justify-between items-center">
        <div className='flex gap-3'>
          <Manage
            type="reference-data"
            tableProps={{
              data,
              loading,
              columns,
              onEdit: handleEdit,
              onDelete: handleDelete,
              emptyMessage: "Không có dữ liệu",
              deleteConfirmMessage: deleteConfirmMessageText
            }}
          />
          <button className='bg-green-500 px-3 py-2 rounded-md' onClick={handleOpenAttachFileManagerModal}> {/* Nút mở modal mới */}
            <KeenIcon icon="paper-clip"/>
          </button>
        </div>
        <Checkbox
          title="Enable Auto Extract"
          checked={isAutoExtractEnabled}
          onChange={(e) => setIsAutoExtractEnabled(e.target.checked)}
        />
      </div>

      {/* Attach File Manager Modal */}
      <AttachFileManagerModal
        isOpen={showAttachFileManagerModal}
        onClose={handleCloseAttachFileManagerModal}
        onSave={handleSaveAttachFile}
      />
    </div>
  );
};

export { ManageAttach };
